/* Bigly Brothers redesign, Sep 30 2026. Small, dependency-free. */
(function () {
  var FR = /^fr/i.test(document.documentElement.lang || '');
  function n1(x) { return FR ? x.toFixed(1).replace('.', ',') : x.toFixed(1); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Keep every product price in sync with the exact variant the form submits.
     Prices are formatted by Shopify, so no amount or currency is hard-coded here. */
  function syncProductPrice(select) {
    var option = select.options[select.selectedIndex];
    var root = select.closest('.shopify-section');
    if (!option || !root) return;
    var price = option.getAttribute('data-bb-variant-price');
    if (price === null) return;
    $all('[data-bb-product-price]', root).forEach(function (el) { el.textContent = price; });
  }
  function syncProductPrices() {
    $all('[data-bb-variant-select]').forEach(syncProductPrice);
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-bb-variant-select]')) syncProductPrice(event.target);
  });
  window.addEventListener('pageshow', syncProductPrices);
  document.addEventListener('shopify:section:load', syncProductPrices);
  syncProductPrices();

  /* Reveal-on-scroll for desktop A+ panels (CSS only animates when motion is allowed) */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $all('.bb-reveal').forEach(function (el) { ro.observe(el); });
  } else { $all('.bb-reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* Mobile A+ "reels": vertical scroll-snap story, progress bars, tap to advance */
  $all('[data-bb-reels]').forEach(function (root) {
    var track = root.querySelector('.bb-reels__track');
    var cards = $all('.bb-reel', track);
    var bars = $all('.bb-reels__bars i', root);
    if (!track || !cards.length) return;
    var idx = 0;
    function paint(i) {
      idx = i;
      bars.forEach(function (b, n) { b.classList.toggle('is-done', n < i); b.classList.toggle('is-on', n === i); });
      root.setAttribute('data-tone', cards[i].getAttribute('data-tone') || 'light');
      track.setAttribute('aria-label', (FR ? 'Élément ' : 'Feature ') + (i + 1) + (FR ? ' sur ' : ' of ') + cards.length);
    }
    function go(i) {
      if (i < 0 || i >= cards.length) return false;
      track.scrollTo({ top: cards[i].offsetTop, behavior: behavior });
      return true;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) paint(cards.indexOf(e.target)); });
      }, { root: track, threshold: [0.6] });
      cards.forEach(function (c) { io.observe(c); });
    }
    track.addEventListener('scroll', function () {
      var h = track.clientHeight || 1; var i = Math.round(track.scrollTop / h);
      if (i !== idx && i >= 0 && i < cards.length) paint(i);
    }, { passive: true });
    cards.forEach(function (c, n) {
      c.addEventListener('click', function (ev) {
        if (ev.target.closest('a,button,input,select')) return;
        var r = c.getBoundingClientRect();
        var back = (ev.clientX - r.left) < r.width * 0.3;
        if (!go(back ? n - 1 : n + 1) && !back) {
          var next = root.parentNode && root.closest('.bb-aplus');
          if (next && next.nextElementSibling) next.nextElementSibling.scrollIntoView({ behavior: behavior });
        }
      });
    });
    track.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight' || ev.key === 'PageDown') { if (go(idx + 1)) ev.preventDefault(); }
      if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft' || ev.key === 'PageUp') { if (go(idx - 1)) ev.preventDefault(); }
    });
    paint(0);
  });

  /* Product gallery: dots + thumbnails for a scroll-snap row */
  $all('[data-bb-gallery]').forEach(function (g) {
    var row = g.querySelector('.bb-gal');
    var items = $all('.bb-gal__item', row);
    var ctrls = $all('[data-bb-go]', g);
    function set(i) { ctrls.forEach(function (b) { b.setAttribute('aria-current', String(+b.getAttribute('data-bb-go') === i)); }); }
    ctrls.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-bb-go');
        row.scrollTo({ left: items[i].offsetLeft - row.offsetLeft, behavior: behavior }); set(i);
      });
    });
    row.addEventListener('scroll', function () {
      var i = Math.round(row.scrollLeft / (row.clientWidth || 1)); set(Math.max(0, Math.min(items.length - 1, i)));
    }, { passive: true });
  });

  /* Sticky add-to-cart bar (phones): shows once the main button has scrolled away */
  var sticky = document.querySelector('[data-bb-sticky]');
  var mainBtn = document.getElementById('bb-main-atc');
  var docEl = document.documentElement;
  if (mainBtn) docEl.classList.add('bb-on-pdp');
  if (mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (sticky) sticky.classList.toggle('is-on', past);
        docEl.classList.toggle('bb-past-buy', past);
      });
    }).observe(mainBtn);
  } else if (mainBtn) { docEl.classList.add('bb-past-buy'); }

  /* Screen-size guide: distance and throw ratio -> approximate 16:9 diagonal */
  $all('[data-bb-calc]').forEach(function (c) {
    var range = c.querySelector('input[type=range]');
    var btns = $all('[data-ratio]', c);
    var out = c.querySelector('[data-out]'), outCm = c.querySelector('[data-out-cm]'), dist = c.querySelector('[data-dist]');
    var screen = c.querySelector('.bb-calc__screen');
    var ratio = +(btns.length ? btns[0].getAttribute('data-ratio') : 1.2);
    btns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') ratio = +b.getAttribute('data-ratio'); });
    function calc() {
      var d = +range.value;
      var w = d / ratio;                      // picture width in metres
      var diag = w * Math.sqrt(256 + 81) / 16; // 16:9 diagonal in metres
      var inch = Math.round(diag * 39.3701);
      out.textContent = inch + '″';
      if (outCm) outCm.textContent = FR ? 'environ ' + Math.round(diag * 100) + ' cm en diagonale, ' + Math.round(w * 100) + ' cm de large' : 'about ' + Math.round(diag * 100) + ' cm diagonal, ' + Math.round(w * 100) + ' cm wide';
      if (dist) dist.textContent = FR ? n1(d) + ' m (' + n1(d * 3.28084) + ' pi) du mur' : d.toFixed(1) + ' m (' + (d * 3.28084).toFixed(1) + ' ft) from the wall';
      if (screen) screen.style.width = Math.min(96, Math.max(8, (w / 4.2) * 100)) + '%';
    }
    range.addEventListener('input', calc);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); ratio = +b.getAttribute('data-ratio'); calc();
      });
    });
    calc();
  });
  /* Row carousels (best sellers, accessories, compare): arrows on desktop, dots on phones, keyboard friendly */
  $all('.bb-rail, .bb-cmp').forEach(function (row, rn) {
    var track = row.classList.contains('bb-cmp') ? row.querySelector('.bb-cmp__grid') : row;
    var items = $all(':scope > *', track);
    if (items.length < 2) return;
    var ctl = document.createElement('div');
    ctl.className = 'bb-rowctl';
    var label = (row.closest('section') && row.closest('section').querySelector('h2')) ? row.closest('section').querySelector('h2').textContent.trim() : 'items';
    ctl.innerHTML = '<div class="bb-rowctl__dots" aria-hidden="true"></div>' +
      '<button type="button" class="bb-rowctl__btn" data-dir="-1" aria-label="' + (FR ? 'Précédent : ' : 'Previous ') + label + '"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="bb-rowctl__btn" data-dir="1" aria-label="' + (FR ? 'Suivant : ' : 'Next ') + label + '"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    row.parentNode.insertBefore(ctl, row.nextSibling);
    var dots = ctl.querySelector('.bb-rowctl__dots');
    items.forEach(function () { dots.appendChild(document.createElement('i')); });
    var btns = $all('.bb-rowctl__btn', ctl);
    function step() { var it = items[0]; var gap = items[1] ? (items[1].offsetLeft - it.offsetLeft - it.offsetWidth) : 12; return it.offsetWidth + gap; }
    function update() {
      var over = row.scrollWidth > row.clientWidth + 4;
      ctl.hidden = !over;
      var max = row.scrollWidth - row.clientWidth - 2;
      btns[0].disabled = row.scrollLeft <= 2;
      btns[1].disabled = row.scrollLeft >= max;
      var i = Math.round(row.scrollLeft / (step() || 1));
      $all('i', dots).forEach(function (d, n) { d.classList.toggle('is-on', n === Math.min(i, items.length - 1) || (row.scrollLeft >= max && n === items.length - 1)); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var per = Math.max(1, Math.floor(row.clientWidth / (step() || 1)));
        row.scrollBy({ left: +b.getAttribute('data-dir') * per * step(), behavior: behavior });
      });
    });
    row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Screen-size visualiser (product pages): side view of wall screen, couch and projector */
  $all('[data-bb-size]').forEach(function (box) {
    var range = box.querySelector('input[type=range]');
    var svg = box.querySelector('svg');
    if (!range || !svg) return;
    var max = +box.getAttribute('data-max'), ratio = +box.getAttribute('data-ratio') || 1.2;
    var verified = box.getAttribute('data-verified') === '1';
    var K = 0.0254 / Math.sqrt(337);            // diagonal inches -> metres per 16:9 unit
    function dims(inch) { var w = inch * K * 16, h = inch * K * 9; return { w: w, h: h, d: w * ratio }; }
    var M = dims(max);
    var WALL = 34, FLOOR = 300;
    var S = Math.min(250 / (M.h + 0.35), 560 / (M.d + 0.3));   // px per metre, fixed per model
    function q(sel) { return svg.querySelector(sel); }
    // couch at a fixed, realistic spot (about 45% of the max distance, at least 2 m)
    var couchX = WALL + Math.max(2, M.d * 0.45) * S;
    var cw = 0.9 * S, ch = 0.45 * S;
    var seat = q('[data-couch-seat]'), back = q('[data-couch-back]'), arm = q('[data-couch-arm]');
    seat.setAttribute('x', couchX - cw * 0.1); seat.setAttribute('y', FLOOR - ch); seat.setAttribute('width', cw); seat.setAttribute('height', ch);
    back.setAttribute('x', couchX + cw * 0.72); back.setAttribute('y', FLOOR - ch * 2.05); back.setAttribute('width', cw * 0.3); back.setAttribute('height', ch * 2.05);
    arm.setAttribute('x', couchX - cw * 0.14); arm.setAttribute('y', FLOOR - ch * 1.35); arm.setAttribute('width', cw * 0.22); arm.setAttribute('height', ch * 1.35);
    function draw() {
      var inch = +range.value, D = dims(inch);
      var bottom = 0.35, sh = D.h * S, sy = FLOOR - bottom * S - sh;
      var scr = q('[data-screen]'); scr.setAttribute('y', sy); scr.setAttribute('height', sh);
      var lbl = q('[data-screen-label]'); lbl.setAttribute('y', Math.max(18, sy - 8)); lbl.textContent = inch + '″';
      var px = WALL + D.d * S, tableH = 0.55 * S, bw = Math.max(26, 0.32 * S), bh = Math.max(15, 0.18 * S);
      var table = q('[data-table]'); table.setAttribute('x', px - 4); table.setAttribute('y', FLOOR - tableH); table.setAttribute('width', bw + 8); table.setAttribute('height', tableH);
      var body = q('[data-body]'); body.setAttribute('x', px); body.setAttribute('y', FLOOR - tableH - bh); body.setAttribute('width', bw); body.setAttribute('height', bh);
      var lx = px + 2, ly = FLOOR - tableH - bh / 2;
      var lens = q('[data-lens]'); lens.setAttribute('cx', lx + 5); lens.setAttribute('cy', ly);
      q('[data-beam]').setAttribute('points', lx + ',' + ly + ' ' + (WALL + 7) + ',' + sy + ' ' + (WALL + 7) + ',' + (sy + sh));
      var dl = q('[data-dimline]'); dl.setAttribute('x2', px);
      var cm = Math.round(inch * 2.54);
      var o = box.querySelector('[data-size]'); if (o) o.textContent = inch + '″';
      var c = box.querySelector('[data-cm]'); if (c) c.textContent = (FR ? 'environ ' + cm + ' cm en diagonale · ' : 'about ' + cm + ' cm diagonal · ') + Math.round(D.w * 100) + ' × ' + Math.round(D.h * 100) + ' cm';
      var d = box.querySelector('[data-dist]'); if (d) d.textContent = FR ? 'Placez le projecteur à environ ' + n1(D.d) + ' m (' + n1(D.d * 3.28084) + ' pi) du mur' + (verified ? '' : ' (approximatif)') : (verified ? 'Projector about ' : 'Projector roughly ') + D.d.toFixed(1) + ' m (' + (D.d * 3.28084).toFixed(1) + ' ft) from the wall' + (verified ? '' : ' (approximate)');
    }
    range.addEventListener('input', draw);
    draw();
  });

  /* Social-proof pop-up (Sales Notification app). It shows real recent orders (checked against Shopify orders).
     Here: at most one every 50 s, short clean product names and white product photos instead of old claim tiles. */
  (function () {
    var CLEAN = [
      ['brother-eye-mark-i-mini', 'Brother Eye Mark I', 'bigly-brothers-mark-i-projector-01-main-white-1500.jpg'],
      ['4k-smart-projector-with-wifi', 'Mark III Elite', 'bigly-brothers-mark-iii-elite-projector-white-2000.jpg'],
      ['brother-eye-mark-iv', 'Mark IV', ''], ['mark-v-native-4k', 'Mark V', ''],
      ['holo-pilot-one', 'Holo Pilot One', 'bigly-brothers-holo-pilot-one-neutral-screen-1600.jpg'],
      ['all-in-1-smart-watch-mens', 'Wristbands of Greater Insight', ''], ['big-time-baddie', 'Big Time Baddie', ''],
      ['road-guardian-1', 'Road Guardian 1', ''], ['road-guardian-2', 'Road Guardian 2', ''], ['road-guardian-3', 'Road Guardian 3', '']
    ];
    var GAP = 50000, active = false;
    function clean(el) {
      var bad = false;
      $all('a[href*="/products/"]', el).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        CLEAN.forEach(function (c) {
          if (href.indexOf(c[0]) > -1) {
            if (a.textContent.trim() && !a.querySelector('*') && a.textContent !== c[1]) a.textContent = c[1];
            var bg = 'url("/cdn/shop/files/' + c[2] + '?width=200")';
            if (c[2] && /background-image/.test(a.getAttribute('style') || '') && a.style.backgroundImage !== bg) a.style.backgroundImage = bg;
          }
        });
      });
      if (/shipping cost|return & replacement/i.test(el.textContent)) bad = true;
      return bad;
    }
    function watch(el) {
      new MutationObserver(function () {
        var on = el.classList.contains('sn-activated');
        if (on && !active) {
          active = true;
          var last = 0; try { last = +sessionStorage.getItem('bbSnLast') || 0; } catch (e) {}
          var bad = clean(el);
          if (bad || Date.now() - last < GAP) { el.classList.add('bb-sn-skip'); }
          else { el.classList.remove('bb-sn-skip'); try { sessionStorage.setItem('bbSnLast', String(Date.now())); } catch (e) {} }
        } else if (!on && active) { active = false; }
        if (on) clean(el);
      }).observe(el, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    var found = document.getElementById('mps-sales-notification');
    if (found) { watch(found); return; }
    var mo = new MutationObserver(function () {
      var el = document.getElementById('mps-sales-notification');
      if (el) { mo.disconnect(); watch(el); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 60000);
  })();
})();


(function () {
  const finders = document.querySelectorAll('[data-bb-finder]');
  if (!finders.length || !('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    document.documentElement.classList.toggle('bb-finder-visible', visible.size > 0);
  });
  finders.forEach(function (finder) { observer.observe(finder); });
})();

